import styled from "@emotion/styled";
import Button from "@mui/material/Button";

export const StyledClearButton = styled(Button)`
  text-transform: inherit;
  column-gap: 0.25rem;
`;
